import { PLAN_IDS } from './constants';

// Types
import type { FeatureFields, PlanId } from './types';
import { Currency } from '@app/account/types';

export const getPlainPlanId = (planId: string) => {
    if (!planId) return planId;

    return planId.replace('-12-month', '').replace('-1-month', '');
};

export const getCurrencyFromPlanId = (planId: string): Currency => {
    if (!planId) {
        return;
    }

    const splitPlanId = planId.split('-');

    const currency = splitPlanId.find((planIdPart) => planIdPart in Currency);

    return (currency as Currency) || Currency.EUR;
};

export const getActiveForPlan = (feature: FeatureFields, planId: PlanId) =>
    ({
        [PLAN_IDS.pro]: feature.activePro,
        [PLAN_IDS.business]: feature.activeBusiness,
        [PLAN_IDS.advanced]: feature.activeAdvanced,
    })[planId];

export const getContingentForPlan = (feature: FeatureFields, planId: PlanId) =>
    ({
        [PLAN_IDS.pro]: feature.contingentPro,
        [PLAN_IDS.business]: feature.contingentBusiness,
        [PLAN_IDS.advanced]: feature.contingentAdvanced,
    })[planId];
